import api from './api'


// const GetProducts = async()=>{
//     return await api.get(`Product/getProducts`).then(res => res.data);
// }

// const GetProducts = async ({ categoryId, subCategoryId } = {}) => {
//   const res = await api.get('Product/getProducts', {
//     params: { categoryId, subCategoryId },
//   });
//   return res.data; // מצפה למערך מוצרים
// }

const GetProducts = async ({ categoryId, searchTerm, page = 1, pageSize = 24 } = {}) => {
  const res = await api.get('Product/getProducts', {
    params: { categoryId, searchTerm, page, pageSize },
  });
  return res.data;
};




const GetproductById = async (id) => {
  return await api.get(`Product/getProductById/${id}`).then(res => res.data);
}

const GetProductsByCategoryId = async (categoryId) => {
  return await api.get(`Product/getProductByCategoryId/${categoryId}`).then(res => res.data);
}

const GetProductOptions = async (productId) => {
  const res = await api.get(`Product/${productId}/options`);
  return res.data; // מערך וריאציות
};


// const AddProduct = async(produc) => {
// return await api.post('Product', produc).then(res => res.data);
// }
const AddProduct = async (product) => {
  // נוודא שזו אכן FormData (כמו שנשלח מ-handleSubmit)
  //   if (!(product instanceof FormData)) {
  //     throw new Error("AddProduct חייב לקבל FormData עם תמונה ונתונים");
  //   }


  // שליחה לשרת בפורמט multipart/form-data
  return api.post("Product", product, {
    headers: { "Content-Type": "multipart/form-data" },
    transformRequest: [(data) => data], // לאפשר ל-Axios לשלוח כמו שהוא
  })
    .then(res => res.data)
    .catch(err => {
      console.error("❌ שגיאה בהוספת מוצר:", err);
      throw err;    
    });
};

const RemoveProduct = async (id) => {
  return await api.delete(`Product/${id}`).then(res => res.data);
}

// const UpdateProduct = async(id, productUpdate) => {
// return await api.put(`Product/${id}`, productUpdate).then(res => res.data);
// }

const UpdateProduct = async (id, data) =>
  api
    .put(
      `Product/${id}`,
      data,
        data instanceof FormData
          ? { headers: { 'Content-Type': 'multipart/form-data' }, transformRequest: [(d) => d] }
          : undefined
    )
    .then(res => res.data);
export { AddProduct, GetProducts, GetProductOptions, RemoveProduct, UpdateProduct, GetProductsByCategoryId, GetproductById }

     